import React from 'react';
import { Database, AlertTriangle, Users, Building, DollarSign, Landmark, ExternalLink } from 'lucide-react';
export function OfficialResources() {
  const resources = [{
    titleEs: 'Portal de Datos Abiertos',
    titleEn: 'Open Data Portal',
    desc: 'Accede a datos públicos e informes de transparencia.',
    descEn: 'Access public data and transparency reports.',
    icon: Database,
    iconColor: 'text-cyan-400',
    iconBg: 'bg-cyan-500/15',
    ring: 'ring-cyan-400/30',
    href: 'https://data.lacity.org/'
  }, {
    titleEs: 'MyLA311',
    titleEn: 'MyLA311',
    desc: 'Reporta problemas: grafiti, baches, alumbrado, basura.',
    descEn: 'Report issues: graffiti, potholes, streetlights, dumping.',
    icon: AlertTriangle,
    iconColor: 'text-amber-400',
    iconBg: 'bg-amber-500/15',
    ring: 'ring-amber-400/30',
    href: 'https://myla311.lacity.org/'
  }, {
    titleEs: 'EmpowerLA',
    titleEn: 'EmpowerLA',
    desc: 'Departamento de Empoderamiento Vecinal de LA.',
    descEn: 'LA Department of Neighborhood Empowerment.',
    icon: Users,
    iconColor: 'text-emerald-400',
    iconBg: 'bg-emerald-500/15',
    ring: 'ring-emerald-400/30',
    href: 'https://empowerla.org/'
  }, {
    titleEs: 'Servicios de la Ciudad',
    titleEn: 'City Services',
    desc: 'Accede a los servicios de la Ciudad de Los Ángeles.',
    descEn: 'Access City of Los Angeles services.',
    icon: Building,
    iconColor: 'text-sky-400',
    iconBg: 'bg-sky-500/15',
    ring: 'ring-sky-400/30',
    href: 'https://lacity.gov/'
  }, {
    titleEs: 'Defensores del Presupuesto',
    titleEn: 'Budget Advocates',
    desc: 'Participación comunitaria en el presupuesto.',
    descEn: 'Community budget participation.',
    icon: DollarSign,
    iconColor: 'text-lime-400',
    iconBg: 'bg-lime-500/15',
    ring: 'ring-lime-400/30',
    href: 'https://empowerla.org/budget-advocates/'
  }, {
    titleEs: 'Concejo Municipal de LA',
    titleEn: 'LA City Council',
    desc: 'Distrito 7 - Concejal Monica Rodriguez.',
    descEn: 'District 7 - Council Member Monica Rodriguez.',
    icon: Landmark,
    iconColor: 'text-violet-400',
    iconBg: 'bg-violet-500/15',
    ring: 'ring-violet-400/30',
    href: 'https://www.lacity.gov/government/city-council'
  }];
  return <section className="py-16 px-6 lg:px-8 bg-charcoal text-white border-t-4 border-sylmar" data-id="element-297">
      <div className="max-w-7xl mx-auto" data-id="element-298">
        <div className="mb-10 text-center md:text-left" data-id="element-299">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-1 notranslate" data-id="element-300">
            Recursos Oficiales
          </h2>
          <p className="text-sky font-medium notranslate italic" data-id="element-301">
            Official Resources
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-302">
          {resources.map((resource, index) => <a href={resource.href} target="_blank" rel="noopener noreferrer" key={index} className="group flex flex-col bg-charcoal-light/50 p-5 rounded-xl border border-charcoal-light hover:border-sylmar hover:bg-charcoal-light hover:-translate-y-1 transition-all duration-300" data-id="element-303">
              <div className="flex justify-between items-start mb-4" data-id="element-304">
                <div className={`${resource.iconBg} ring-1 ${resource.ring} p-3 rounded-xl w-14 h-14 flex items-center justify-center group-hover:scale-110 transition-transform`} data-id="element-305">
                  <resource.icon className={`w-7 h-7 ${resource.iconColor}`} strokeWidth={2} data-id="element-306" />
                </div>
                <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-white transition-colors" data-id="element-307" />
              </div>
              <h3 className="font-bold text-white mb-0.5 group-hover:text-sylmar-light transition-colors leading-tight notranslate" data-id="element-308">
                {resource.titleEs}
              </h3>
              <span className="block text-sky text-xs italic mb-2 notranslate" data-id="element-309">
                {resource.titleEn}
              </span>
              <div className="text-xs text-gray-400 leading-relaxed flex-grow space-y-1 mt-1" data-id="element-310">
                <p data-id="element-311">{resource.desc}</p>
                <p className="text-gray-500 italic" data-id="element-312">{resource.descEn}</p>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}